export default __webpack_public_path__ + "static/media/getfy.1c5ed57e.svg";